import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFormData } from 'formal_quote/slice';
import { getUrlParam, mapUrlParamToSoftwareType } from 'formal_quote/utils';

const LOOKING_FOR_NEW_LICENSE = 'new_license';

export const useFormInitialization = ({ paramName = 'software' } = {}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const urlParam = getUrlParam(paramName);
    const softwareType = mapUrlParamToSoftwareType(urlParam);

    if (softwareType) {
      dispatch(
        setFormData({
          looking_for: LOOKING_FOR_NEW_LICENSE,
          software_type: softwareType,
        }),
      );
    }
  }, [dispatch, paramName]);
};
